import classNames from 'classnames';
import React, {FC, useId} from 'react';
import style from './style.module.scss';

export const LOADER_COLOR = {
    black: 'black',
    red: 'red',
    white: 'white',
} as const;

export const LOADER_SIZE = {
    lg: 'lg',
    md: 'md',
    sm: 'sm',
    xl: 'xl',
} as const;

export type TLoaderColor = keyof typeof LOADER_COLOR;
export type TLoaderSize = keyof typeof LOADER_SIZE;

export interface ILoaderProps {
    className?: string;
    color?: TLoaderColor;
    size?: TLoaderSize;
}

export interface ILogoLoaderProps {
    className?: string;
    isLoading?: boolean;
    isNotForReload?: boolean;
    fixed?: boolean;
}

export const Loader: FC<ILoaderProps> = ({className, color = LOADER_COLOR.black, size = LOADER_SIZE.lg}) => {
    const key = useId();

    return (
        <svg
            xmlns={'http://www.w3.org/2000/svg'}
            width={'24'}
            height={'24'}
            viewBox={'0 0 44 44'}
            fill={'none'}
            id={`loader-${key}`}
            key={key}
            className={classNames(style.root, className, {
                [style[size]]: Boolean(size),
                [style[color]]: Boolean(color),
            })}
        >
            <path
                d={
                    'M21.9998 3.66669C19.5923 3.66669 17.2083 4.14089 14.984 5.06223C12.7597 5.98357 10.7386 7.33399 9.03621 9.0364C7.33381 10.7388 5.98338 12.7599 5.06205 14.9842C4.14071 17.2085 3.6665 19.5925 3.6665 22C3.6665 24.4076 4.14071 26.7916 5.06205 29.0159C5.98338 31.2402 7.33381 33.2612 9.03621 34.9636C10.7386 36.6661 12.7597 38.0165 14.984 38.9378C17.2083 39.8591 19.5923 40.3334 21.9998 40.3334V38.5C19.833 38.5 17.6874 38.0732 15.6856 37.244C13.6837 36.4148 11.8647 35.1994 10.3326 33.6673C8.80041 32.1351 7.58503 30.3162 6.75583 28.3143C5.92662 26.3124 5.49984 24.1668 5.49984 22C5.49984 19.8332 5.92662 17.6876 6.75583 15.6857C7.58503 13.6839 8.80041 11.8649 10.3326 10.3328C11.8647 8.80059 13.6837 7.58521 15.6856 6.75601C17.6874 5.92681 19.833 5.50002 21.9998 5.50002V3.66669Z'
                }
                fill={'currentColor'}
                style={{
                    transformOrigin: 'center',
                    animation: 'spin 1.25s linear infinite',
                }}
            />
            <style>{`@keyframes spin {from {transform: rotate(0deg);} to{transform: rotate(360deg);}`}</style>
        </svg>
        // <svg
        //     xmlns={'http://www.w3.org/2000/svg'}
        //     width={'24'}
        //     height={'24'}
        //     viewBox={'0 0 24 24'}
        //     fill={'none'}
        //     id={`loader-${key}`}
        //     key={key}
        //     className={classNames(style.root, className, {
        //         [style[size]]: Boolean(size),
        //         [style[color]]: Boolean(color),
        //     })}
        //     style={{
        //         transformOrigin: 'center',
        //         animation: 'spin 1.25s linear infinite',
        //     }}
        // >
        //     <path
        //         d={
        //             'M21.9998 3.66669C19.5923 3.66669 17.2083 4.14089 14.984 5.06223C12.7597 5.98357 10.7386 7.33399 9.03621 9.0364C7.33381 10.7388 5.98338 12.7599 5.06205 14.9842C4.14071 17.2085 3.6665 19.5925 3.6665 22C3.6665 24.4076 4.14071 26.7916 5.06205 29.0159C5.98338 31.2402 7.33381 33.2612 9.03621 34.9636C10.7386 36.6661 12.7597 38.0165 14.984 38.9378C17.2083 39.8591 19.5923 40.3334 21.9998 40.3334V38.5C19.833 38.5 17.6874 38.0732 15.6856 37.244C13.6837 36.4148 11.8647 35.1994 10.3326 33.6673C8.80041 32.1351 7.58503 30.3162 6.75583 28.3143C5.92662 26.3124 5.49984 24.1668 5.49984 22C5.49984 19.8332 5.92662 17.6876 6.75583 15.6857C7.58503 13.6839 8.80041 11.8649 10.3326 10.3328C11.8647 8.80059 13.6837 7.58521 15.6856 6.75601C17.6874 5.92681 19.833 5.50002 21.9998 5.50002V3.66669Z'
        //         }
        //         stroke={'currentColor'}
        //     />
        //     <style>{`@keyframes spin {from {transform: rotate(0deg);} to{transform: rotate(360deg);}`}</style>
        // </svg>
    );
};
